import type { FC } from 'react';
import React from 'react';

import { useSessionData } from '@confluence/session-data';
import { fg } from '@confluence/feature-gating';

import { PageCatchupPopupComponent } from './PageCatchupPopupComponent';

type PageCatchupPopupForPageHistoryProps = {
	contentId: string;
	contentType: string;
	spaceKey: string | undefined;
	source: string;
	selectedVersions: Set<any>;
	contentPath: string;
};

export const PageCatchupPopupForPageHistory: FC<PageCatchupPopupForPageHistoryProps> = ({
	contentId,
	contentType,
	spaceKey,
	source,
	selectedVersions,
	contentPath,
}) => {
	const { isAdminHubAIEnabled } = useSessionData();
	const isDisabled = selectedVersions.size < 2;

	const shouldRenderPageCatchupPopup =
		isAdminHubAIEnabled && fg('cc_ai_consumption_page_catchup_in_page_history');

	if (shouldRenderPageCatchupPopup) {
		return (
			<PageCatchupPopupComponent
				contentId={contentId}
				contentType={contentType}
				spaceKey={spaceKey ?? ''}
				isDisabled={isDisabled}
				source={source}
				selectedVersions={selectedVersions}
				contentPath={contentPath}
			/>
		);
	}

	return null;
};
